import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const useAsyncConfigs = ({ names, branchGuid, requestDriverRateData = sendRequest }) => {
  const [state, setState] = useState({ asyncConfigs: null, asyncConfigsLoading: false });

  useEffect(() => {
    const getConfigsRequest = async () => {
      const branchGuidToUse = R.or(branchGuid, G.getAmousCurrentBranchGuidFromWindow());

      if (R.or(G.isNilOrEmpty(branchGuidToUse), G.isNilOrEmpty(names))) return;

      setState((prev) => ({ ...prev, asyncConfigsLoading: true }));

      const params = { names: R.join(',', names), [GC.FIELD_BRANCH_GUID]: branchGuidToUse };

      const res = await requestDriverRateData('get', endpointsMap.branchConfigsEndpoint, { params });

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        if (G.isNotEmpty(data)) {
          const mapped = G.mapConfigValuesByName(data);

          setState((prev) => ({ ...prev, asyncConfigs: mapped, asyncConfigsLoading: false }));
        }
      } else {
        setState((prev) => ({ ...prev, asyncConfigsLoading: false }));

        G.handleFailResponseSimple(
          res,
          false,
          'withAsyncConfigs -> getConfigsRequest',
        );
      }
    };

    getConfigsRequest({ names, branchGuid });
  }, []);

  return state;
};

export const withAsyncConfigs = (Component) => (props) => {
  const { branchGuid, configsNamesArray, requestDriverRateData } = props;

  const { asyncConfigs, asyncConfigsLoading } = useAsyncConfigs({
    branchGuid,
    requestDriverRateData,
    names: configsNamesArray,
  });

  return (
    <Component
      {...props}
      asyncConfigs={asyncConfigs}
      asyncConfigsLoading={asyncConfigsLoading}
    />
  );
};

const getConfigsPropObject = (configsPropName, asyncConfigs) => G.ifElse(
  G.isNotNilAndNotEmpty(configsPropName),
  { [configsPropName]: asyncConfigs },
  { asyncConfigs },
);

export const withAsyncConfigsNamed = ({ configsPropName }) => (Component) => (props) => {
  const { branchGuid, configsNamesArray } = props;

  const { asyncConfigs } = useAsyncConfigs({ names: configsNamesArray, branchGuid });

  return (
    <Component
      {...props}
      {...getConfigsPropObject(configsPropName, asyncConfigs)}
    />
  );
};
